import type { LayoutBaseSpacingProps } from '@bos/ui';
import { formatDateToISODays } from '@bos/utils';

import { MediaTypeV5 } from './api/generated/cz.partners.bank.backofficegateway.documents';
/**
 * Number of default items per page/load.
 */
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_NUMBER = 0;
export const DEFAULT_LOAD_MORE = 0;

export const DEFAULT_CZECH_CURRENCY_CODE = 'CZK';

export const BANK_INCEPTION_DATE = new Date(2023, 10, 1);
export const TODAYS_DATE = new Date();

export const PERCENT_VALUE_PRECISION = 2;

export const DEFAULT_CARD_CONTENT_SPACING: LayoutBaseSpacingProps = {
	spacing: '2',
};

export const MEDIA_TYPE_OPTIONS_MAP: Record<MediaTypeV5, string> = {
	[MediaTypeV5.APPLICATION_PDF]: 'PDF',
	[MediaTypeV5.TEXT_CSV]: 'CSV',
};

/**
 * In milliseconds.
 */
export const SEARCH_VALUE_DEBOUNCE_TIME = 400;

export const MONTH_AND_YEAR_TIMESTAMP_DATE_FORMAT = 'LLLL yyyy';
export const WEEKDAY_DAY_MONTH_DATE_FORMAT = 'EEEE, dd. MM.';
export const MAX_VALID_PLAIN_DATE = '3000-01-01';

export const MAX_VALID_DATE: Date = new Date(MAX_VALID_PLAIN_DATE);
export const FORMATTED_MAX_VALID_DATE: string =
	formatDateToISODays(MAX_VALID_DATE);

export const TAB_CHARACTER = '\t';
export const NEW_LINE_CHARACTER = '\n';
export const NEW_PARAGRAPH_CHARACTER = '\n\n';

export const CURRENCY_CODE_LENGTH = 3;

export const FEW_ITEMS_TRANSLATION_MIN_LIMIT = 2;
export const FEW_ITEMS_TRANSLATION_MAX_LIMIT = 4;

export const SINGLE_ITEM_COUNT = 1;
